import { deprecated } from "typesafe-actions";

import type { ITreeStructure } from "@/shop/types/tree";

import { PartTreeActionType } from "./constants";

const { createStandardAction } = deprecated;

/**
 * Fetch tree for specific from an url
 */
export const fetchTree = createStandardAction(PartTreeActionType.FETCH_TREE).map((url: string) => ({ payload: { url } }));

export const fetchTreeStart = createStandardAction(PartTreeActionType.FETCH_TREE_START).map((url: string) => ({ payload: { url } }));

export const fetchTreeFail = createStandardAction(PartTreeActionType.FETCH_TREE_FAIL).map((url: string) => ({ payload: { url } }));

export const fetchTreeSuccess = createStandardAction(PartTreeActionType.FETCH_TREE_SUCCESS).map(({ url, tree }: { url: string; tree: ITreeStructure }) => ({
  payload: { url, tree }
}));
